export const styles = {
  notificationItem: (theme) => ({
    cursor: "pointer",
    p: 1,
    borderRadius: "5px",
    position: "relative",
    pr: 1.8745,
    width: "100%",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.common.black,
    "&:hover": {
      backgroundColor: theme.palette.background.hover,
    },
  }),
  unreadNotification: (theme) => ({
    backgroundColor: theme.palette.background.activity,
    "&:before": {
      content: '""',
      position: "absolute",
      right: 7,
      top: 15,
      width: 14,
      height: 14,
      borderRadius: 10,
      backgroundColor: theme.palette.primary.main,
    },
  }),
  avatar: {
    width: 52,
    height: 52,
  },
  notificationItemContent: {
    width: "calc(100% - 56px)",
    pl: 1.8745,
    flexWrap: "nowrap",
    justifyContent: "flex-start",
  },
  notificationTitle: {
    fontSize: 14,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontWeight: "bold",
  },
  notificationItemAction: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: 14,
  }),
  notificationItemDate: (theme) => ({
    color: theme.palette.primary.main,
    fontSize: 10,
    fontWeight: "bold",
    textTransform: "capitalize",
  }),
  notificationItemGroup: {
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: 10,
    color: "#84818a",
  },
  notificationGroupIcon: {
    marginRight: 5,
    fontSize: 10,
  },
  notificationItemText: {
    "& svg": {
      color: "#84818a",
      ml: "5px",
      fontSize: 14,
    },
  },
}
